'use strict';

import React, {useEffect} from 'react';
import CareRequestNotification from './medixine/CareRequestNotification';
import QuestionnaireNotification from './omavointi/QuestionnaireNotification';
import FormulaNotification from './formula/FormulaNotification';
import { partition } from 'lodash';
import QuestionnaireNotificationList from './omavointi/QuestionnaireNotificationList';

const { id: module_id } = module;

class QuestionnaireNotificationContainer extends React.Component {
  render() {
    const { items, children, formulaFormConfigs } = this.props;
    let [omavointiItems, otherItems] = partition(
      items,
      (item) =>
        item.type === 'OmavointiQuestionnaire' &&
        item.formCode !== 'feeling_app'
    );

    return (
      <>
        <ul style={{ marginLeft: 0 }}>
          <>
            {omavointiItems.length > 0 && (
              <li>
                <QuestionnaireNotificationList
                  key={omavointiItems[0].link}
                  data={omavointiItems}
                />
              </li>
            )}
            {otherItems.map((query, i) => {
              if (query.formulaFormId) {
                return (
                  <FormulaNotification
                    showActiveQuestionnaireDescription={
                      query.showActiveQuestionnaireDescription
                    }
                    key={`${query.formulaFormId}_${i}`}
                    data={query}
                    formConfigs={formulaFormConfigs}
                  />
                );
              } else {
                switch (query.type) {
                  case 'Questionnaire':
                    return (
                      <CareRequestNotification
                        showActiveQuestionnaireDescription={
                          query.showActiveQuestionnaireDescription
                        }
                        key={`${query.link}_${i}`}
                        data={query}
                      />
                    );
                  case 'OmavointiQuestionnaire':
                    return (
                      <QuestionnaireNotification
                        showActiveQuestionnaireDescription={
                          query.showActiveQuestionnaireDescription
                        }
                        key={`${query.link}_${i}`}
                        data={query}
                      />
                    );
                  case 'AssignableQuestionnaire':
                    return (
                      <QuestionnaireNotification
                        showActiveQuestionnaireDescription={
                          query.showActiveQuestionnaireDescription
                        }
                        key={`${query.id}_${i}`}
                        data={query}
                      />
                    );
                  case 'FinnGenQuestionnaire':
                    return (
                      <QuestionnaireNotification
                        showActiveQuestionnaireDescription={
                          query.showActiveQuestionnaireDescription
                        }
                        key={`${query.link}_${i}`}
                        data={query}
                      />
                    );
                }
              }
            })}
          </>
        </ul>
        {children}
      </>
    );
  }
}

export default QuestionnaireNotificationContainer;
